module.exports = __webpack_public_path__ + "static/media/car-bump.efbe34a7.svg";